import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { doc, updateDoc, arrayUnion } from 'firebase/firestore';
import { db } from '../firebase';

// ── VAPID key ──────────────────────────────────────────────────────────────
// Get this from: Firebase Console → Project Settings → Cloud Messaging
// → Web Push certificates → Add certificate → copy the Key pair (public key)
export const VAPID_KEY = 'BM5TDIOJEFA9OrFQXBjEjB57hLn9eUynjHl5Bu3eEA65L0GzI3tUE-h25xWAqX9KQbN7WOi4mIirn4q2CL21e-E';
// ────────────────────────────────────────────────────────────────────────────

let _messaging = null;
function getMsg() {
  if (!_messaging) _messaging = getMessaging();
  return _messaging;
}

/**
 * Asks the user for notification permission, gets an FCM token,
 * and saves it to their Firestore student document.
 * Safe to call multiple times — won't re-prompt if already granted.
 */
export async function registerForNotifications(userId) {
  try {
    if (!('Notification' in window)) return;          // browser doesn't support it
    if (VAPID_KEY === 'REPLACE_WITH_YOUR_VAPID_KEY') return; // not yet configured

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    // Explicitly register the service worker so getToken can bind to it.
    // Without this, FCM silently fails on many browsers/devices.
    const sw = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

    const token = await getToken(getMsg(), {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: sw,
    });
    if (token && userId) {
      await updateDoc(doc(db, 'students', userId), {
        fcmTokens: arrayUnion(token),
      });
    }
  } catch (e) {
    // Silently ignore — notifications are optional
    console.warn('FCM registration failed:', e.message);
  }
}

/**
 * Listen for notifications while the app is in the foreground.
 * Returns unsubscribe function.
 */
export function onForegroundMessage(callback) {
  try {
    return onMessage(getMsg(), callback);
  } catch {
    return () => {};
  }
}
